import * as React from 'react';
import styled from '@emotion/styled';
import { observer } from 'src/utils/mobx-react';

interface PropsType {
    className?: string;
    onClick?: () => void;
}

const SvgElement = styled('svg', { label: 'SvgElement' })`
    height: auto;
`;

export const MMAIcon = observer('MMAIcon', ({ className, onClick }: PropsType): JSX.Element => {
    return (
        <SvgElement
            xmlns='http://www.w3.org/2000/svg'
            width='16'
            height='16'
            viewBox='0 0 16 16'
            fill='none'
            className={className}
            onClick={onClick}
        >
            <mask
                id='mMAMask'
                width='10'
                height='13'
                x='3'
                y='2'
                maskUnits='userSpaceOnUse'
                style={{ maskType: 'alpha' }}
            >
                <path
                    fill='#142448'
                    d='M5.333 14.1a.65.65 0 0 1-.475-.192.65.65 0 0 1-.191-.475v-2h6.666v2a.65.65 0 0 1-.191.475.65.65 0 0 1-.475.192zm7.334-8.667v2a.4.4 0 0 1-.034.134l-.5 2.533a.76.76 0 0 1-.275.483.8.8 0 0 1-.525.184H4.667a.8.8 0 0 1-.525-.184.76.76 0 0 1-.275-.483l-.5-2.533a.4.4 0 0 1-.034-.134v-4q0-.55.392-.941.391-.392.942-.392H10q.55 0 .942.392.39.391.391.941v2q0-.283.192-.475A.65.65 0 0 1 12 4.767q.283 0 .475.191a.65.65 0 0 1 .192.475M5.333 6.767h4v-2h-4z'
                />
            </mask>
            <g mask='url(#mMAMask)'>
                <path
                    fill='#0b1627'
                    fillOpacity='.64'
                    d='M0 0h16v16H0z'
                />
            </g>
        </SvgElement>
    );
});
